import { CUSTOM_TYPES, FIELD_TYPE_BOOLEAN } from "@/domains/profile/constants/custom-types";
import { FIELD_TYPE_COVID, FIELD_TYPE_TRAVELING_WORK, SYSTEM_TYPES } from "@/domains/profile/constants/system-types";

const SELECTORS = {
    field: "[data-profile-field]",
    innerField: ".profile-field",
    label: [
        ".c-input-floating-label-not-visible",
        ".c-select-floating-label-not-visible",
        ".hidden-label",
        "[data-type='date'] .c-input-label",
        "[data-type='period'] .c-input-label",
    ].join(","),
};

const LOGIC_TYPES = [
    CUSTOM_TYPES[FIELD_TYPE_BOOLEAN],
    SYSTEM_TYPES[FIELD_TYPE_COVID],
    SYSTEM_TYPES[FIELD_TYPE_TRAVELING_WORK],
].map((type) => type.id);

function resetField(field) {
    field.style.paddingTop = "";
}

function setFieldOffset(field, offset) {
    field.style.paddingTop = `${offset}px`;
}

function getFieldMetrics(field) {
    const inner = field.querySelector(SELECTORS.innerField);
    const label = inner.querySelector(SELECTORS.label);

    const { type } = field.dataset;

    const { top } = field.getBoundingClientRect();
    const height = field.offsetHeight;
    const innerHeight = inner.offsetHeight;
    const labelHeight = label ? label.offsetHeight : 0;

    return {
        element: field,
        type,
        top,
        height,
        inner,
        innerHeight,
        label,
        labelHeight,
    };
}

function findRow(rows, fieldMetrics) {
    return rows.find((row) => {
        const [first] = row;
        return fieldMetrics.top === first.top && fieldMetrics.height === first.height;
    });
}

function alignRow(row) {
    if (row.length < 2) return;

    // элементы с лейблами (инпуты, селекты)
    const labeledFields = row.filter((field) => field.label);
    // логические поля
    const booleanFields = row.filter((field) => LOGIC_TYPES.includes(field.type));

    // console.log({ row, labeledFields, booleanFields });

    if (labeledFields.length >= 2) {
        const maxLabelHeight = labeledFields.reduce((max, el) => Math.max(max, el.labelHeight), 0);

        labeledFields.forEach((field) => {
            setFieldOffset(field.element, maxLabelHeight - field.labelHeight);
        });
    }

    if (booleanFields.length >= 2) {
        const maxHeight = booleanFields.reduce((max, el) => Math.max(max, el.innerHeight), 0);

        booleanFields.forEach((field) => {
            setFieldOffset(field.element, (maxHeight - field.innerHeight) / 2);
        });
    }
}

export function alignRows(root) {
    const $fields = [...root.querySelectorAll(SELECTORS.field)];
    $fields.forEach(resetField);
    const fieldsWithMetrics = $fields.map(getFieldMetrics);

    const rows = [];

    fieldsWithMetrics.forEach((field) => {
        const row = findRow(rows, field);
        if (row) row.push(field);
        else rows.push([field]);
    });

    rows.forEach(alignRow);

    // console.log({ rows });
}
